import {BrowserRouter as Router,Route,Link} 
from 'react-router-dom';
import React , { Component } from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import logo from './img/logo.png';
import {
  Collapse, Navbar, NavbarToggler, NavbarBrand,
  Nav, NavItem,  NavLink,InputGroup,InputGroupAddon, Input,
  Button
} from 'reactstrap';
 
export default class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div>
      <div className="navbar-fixed-top">
        <Navbar light expand="md" >
          <NavbarBrand>
            <NavLink href="/">
              <img src={logo} style={{width:"180px"}} />
            </NavLink>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar >
            <Nav className="ml-auto" navbar right>
              <NavItem>
                <NavLink className="page-scroll" href="/about">About</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="page-scroll" href="/products">Products</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="page-scroll" href="/service"> Service</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="page-scroll" href="/blog"> Blog</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="page-scroll" href="/contact">Contact</NavLink>
              </NavItem>
              <NavItem>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                <Input type="text" className="form-control" placeholder="Search"/>
                <Button type="submit" color="primary"  outline style={{borderRadius:5}}>&#9752;</Button>
                </InputGroupAddon>
              </InputGroup>
              </NavItem>
            </Nav>          
          </Collapse>
        </Navbar>
        </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/menu.js